import Icon from '@components/Icon'
import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { SIZES } from '../constants'

export class DividerBlock {
  constructor(props) {
    this.data = {
      size: props.data.size ?? 'small'
    }
    this.element = undefined
    this.api = props.api
  }

  static get toolbox() {
    return {
      title: 'Mellanrum',
      icon: renderToStaticMarkup(<Icon icon={'SpaceBetween'}/>),
    }
  }

  renderSettings(){
    const settings = [
      {
        name: 'small',
        icon: renderToStaticMarkup(<Icon icon={'Small'}/>),
        title: 'Liten'
      },
      {
        name: 'medium',
        icon: renderToStaticMarkup(<Icon icon={'Medium'}/>),
        title: 'Mellan'
      },
      {
        name: 'large',
        icon: renderToStaticMarkup(<Icon icon={'Large'}/>),
        title: 'Stor'
      }
    ]
    const wrapper = document.createElement('div')

    settings.forEach(tune => {
      let button = document.createElement('div')

      button.classList.add('cdx-settings-button')
      button.innerHTML = tune.icon
      wrapper.appendChild(button)

      this.api.tooltip.onHover(button, tune.title);

      button.addEventListener('click', () => {
        this.data.size = tune.name
        this.element.style.height = SIZES[tune.name]
      })
    })

    return wrapper
  }

  save() {
    return {size: this.data.size}
  }

  render() {
    this.element  = document.createElement('div')
    this.element.style.height = SIZES[this.data.size]
    this.element.style.backgroundImage = `linear-gradient(45deg, #f8f8f8 25%, #ffffff 25%, #ffffff 50%, #f8f8f8 50%, #f8f8f8 75%, #ffffff 75%, #ffffff 100%)`
    this.element.style.backgroundSize = `42.43px 42.43px`

    return this.element
  }
}
